<template>
    <div class="row">
        <!-- Cards -->
        <div class="col-12">
            <!-- Datos Legales -->
            <div class="card">
                <div class="card-header py-3">
                    <h5 class="mb-0 text-gray-6 text-uppercase">
                        <fa-icon :icon="['far', 'id-card']" :class="['mr-2']" /> Datos Legales
                    </h5>
                </div>
                <div :class="['card-body', $style.generalCard]">
                    <div class="row d-flex align-items-top">
                        <div class="col-12 col-md-4 mb-lg-0 align-items-left">
                            <g-field v-model="fields.name" :app="app" :item="id" name="name" title="Nombre" />
                            <g-field v-model="fields.alias" :app="app" :item="id" name="alias" title="Alias" />
                            <g-field v-model="fields.email" :app="app" :item="id" name="email" title="Email" />
                        </div>
                        <div class="col-12 col-md-4 mb-lg-0 align-items-left">
                            <g-field
                                v-model="fields.legal_name"
                                :app="app"
                                :item="id"
                                name="legal_name"
                                title="Razón Social"
                            />
                            <g-field v-model="fields.phone" :app="app" :item="id" name="phone" title="Teléfono" />
                        </div>
                        <div class="col-12 col-md-4 mb-lg-0 align-items-left">
                            <g-field v-model="fields.cif" :app="app" :item="id" name="cif" title="NIF / CIF" />
                            <g-field
                                v-model="fields.mobile_phone"
                                :app="app"
                                :item="id"
                                name="mobile_phone"
                                title="Móvil"
                            />
                        </div>
                    </div>
                </div>
                <div class="card-footer d-flex">
                    <a-button class="ml-auto" type="primary" :loading="loading" @click="save"> Guardar </a-button>
                </div>
            </div>

            <!-- Datos Legales -->
            <div class="card">
                <div class="card-header py-3">
                    <h5 class="mb-0 text-gray-6 text-uppercase">
                        <fa-icon :icon="['far', 'map-marker']" :class="['mr-2']" /> Localización
                    </h5>
                </div>

                <div :class="['card-body', $style.generalCard]">
                    <div class="row d-flex align-items-top">
                        <div class="col-12 col-md-4 mb-lg-0 align-items-left">
                            <g-field v-model="fields.address" :app="app" :item="id" name="address" title="Dirección" />
                            <g-field v-model="fields.country" :app="app" :item="id" name="country" title="Pais" />
                        </div>
                        <div class="col-12 col-md-4 mb-lg-0 align-items-left">
                            <g-field
                                v-model="fields.location"
                                :app="app"
                                :item="id"
                                name="location"
                                title="Población"
                            />
                            <g-field v-model="fields.cp" :app="app" :item="id" name="cp" title="Código Postal" />
                        </div>
                        <div class="col-12 col-md-4 mb-lg-0 align-items-left">
                            <g-field v-model="fields.state" :app="app" :item="id" name="state" title="Provincia" />
                        </div>
                    </div>
                </div>
                <div class="card-footer d-flex">
                    <a-button class="ml-auto" type="primary" :loading="loading" @click="save"> Guardar </a-button>
                </div>
            </div>

            <!-- Datos de facturacion -->
            <div v-if="$gestios.auth.check({ scopes: ['_BOSS'] })" class="card">
                <div class="card-header py-3">
                    <h5 class="mb-0 text-gray-6 text-uppercase">
                        <fa-icon :icon="['far', 'dollar-sign']" :class="['mr-2']" /> Facturación
                    </h5>
                </div>
                <div :class="['card-body', $style.generalCard]">
                    <div class="row d-flex align-items-center">
                        <div class="col-12 col-md-4 mb-lg-0 align-items-left">
                            <h5>Método de pago:</h5>
                            <g-field
                                v-model="fields.payment_method"
                                :app="app"
                                :item="id"
                                name="payment_method"
                                placeholder="Método de pago"
                                :clean="true"
                            />
                        </div>
                        <div class="col-12 col-md-4 mb-lg-0 align-items-left">
                            <h5>Tarifa</h5>
                            <g-field
                                v-model="fields.rate"
                                :app="app"
                                :item="id"
                                table="rates"
                                column-search="text"
                                name="rate"
                                placeholder="Tarifa"
                                :clean="true"
                            />
                        </div>
                        <div class="col-12 col-md-4 mb-lg-0 align-items-left">
                            <g-field
                                v-model="fields.show_prices"
                                :app="app"
                                :item="id"
                                name="show_prices"
                                placeholder="Mostrar precios"
                                type="boolean"
                                size="large"
                                :clean="true"
                            />
                        </div>
                    </div>
                    <div class="row d-flex align-items-center mt-4">
                        <div class="col-12 col-md-4 mb-lg-0 align-items-left">
                            <h5>IBAN:</h5>
                            <g-field
                                v-model="fields.iban"
                                :app="app"
                                :item="id"
                                name="iban"
                                placeholder="IBAN"
                                :clean="true"
                            />
                        </div>
                        <div class="col-12 col-md-4 mb-lg-0 align-items-left">
                            <h5>BIC / SWIFT:</h5>
                            <g-field
                                v-model="fields.bic_swift"
                                :app="app"
                                :item="id"
                                name="bic_swift"
                                placeholder="BIC/SWIFT"
                                :clean="true"
                            />
                        </div>
                        <div class="col-12 col-md-4 mb-lg-0 align-items-left">
                            <g-field
                                v-model="fields.surcharge"
                                :app="app"
                                :item="id"
                                name="surcharge"
                                placeholder="Recargo de equivalencia"
                                type="boolean"
                                size="large"
                                :clean="true"
                            />
                        </div>
                    </div>
                </div>
                <div class="card-footer d-flex">
                    <a-button class="ml-auto" type="primary" :loading="loading" @click="save"> Guardar </a-button>
                </div>
            </div>

            <!-- Otros Datos -->
            <div class="card">
                <div class="card-header py-3">
                    <h5 class="mb-0 text-gray-6 text-uppercase">
                        <fa-icon :icon="['far', 'file-invoice']" :class="['mr-2']" /> Factura Electrónica
                    </h5>
                </div>
                <div :class="['card-body', $style.generalCard]">
                    <div class="row d-flex align-items-top">
                        <div class="col-12 col-md-4 mb-lg-0 align-items-left">
                            <g-field
                                v-model="fields.buyer_code"
                                :app="app"
                                :item="id"
                                name="buyer_code"
                                title="Codigo de comprador"
                            />
                            <g-field
                                v-model="fields.receiver_code_bill"
                                :app="app"
                                :item="id"
                                name="receiver_code_bill"
                                title="Código Receptor de la factura"
                            />
                        </div>
                        <div class="col-12 col-md-4 mb-lg-0 align-items-left">
                            <g-field
                                v-model="fields.contract_num"
                                :app="app"
                                :item="id"
                                name="contract_num"
                                title="Nº Contrato"
                            />
                            <g-field
                                v-model="fields.receiver_code_goods"
                                :app="app"
                                :item="id"
                                name="receiver_code_goods"
                                title="Código Receptor de las Mercaderías"
                            />
                        </div>
                        <div class="col-12 col-md-4 mb-lg-0 align-items-left">
                            <g-field
                                v-model="fields.deliveries_relation_num"
                                :app="app"
                                :item="id"
                                name="deliveries_relation_num"
                                title="Numero de Relación de Entregas"
                            />
                            <g-field
                                v-model="fields.receiver_code_payment"
                                :app="app"
                                :item="id"
                                name="receiver_code_payment"
                                title="Codigo Receptor del Pago"
                            />
                        </div>
                    </div>
                </div>
                <div class="card-footer d-flex">
                    <a-button class="ml-auto" type="primary" :loading="loading" @click="save"> Guardar </a-button>
                </div>
            </div>

            <!-- Otros Datos -->
            <div class="card">
                <div class="card-header py-3">
                    <h5 class="mb-0 text-gray-6 text-uppercase">
                        <fa-icon :icon="['far', 'plus-circle']" :class="['mr-2']" /> Adicionales Electrónica
                    </h5>
                </div>
                <div :class="['card-body', $style.generalCard]">
                    <div class="row d-flex align-items-top">
                        <!-- Observaciones impromibles -->
                        <div class="col-12 col-md-6 mb-lg-0 align-items-left">
                            <g-field
                                v-model="fields.printable_observations"
                                :app="app"
                                :item="id"
                                name="printable_observations"
                                title="Observaciones para imprimir"
                                type="textarea"
                            />
                        </div>
                        <!-- Observaciones no impromibles -->
                        <div class="col-12 col-md-6 mb-lg-0 align-items-left">
                            <g-field
                                v-model="fields.no_printable_observations"
                                :app="app"
                                :item="id"
                                name="no_printable_observations"
                                title="Observaciones (no imprimibles)"
                                placeholder="Observaciones (no imprimibles)"
                                type="textarea"
                            />
                        </div>
                    </div>
                </div>
                <div class="card-footer d-flex">
                    <a-button class="ml-auto" type="primary" :loading="loading" @click="save"> Guardar </a-button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        id: {
            type: Number,
            default: 0,
        },
        client: {
            type: Object,
            default: null,
        },
    },
    data() {
        return {
            app: 'clients',
            loading: false,
            fields: {
                name: '',
                legal_name: '',
                email: '',
                cif: '',
                address: '',
                cp: '',
                location: '',
                state: '',
                country: '',
                phone: '',
                mobile_phone: '',
                rate: 0,
                surcharge: 0,
                payment_method: 0,
                show_prices: 0,
                iban: '',
                bic_swift: '',
                printable_observations: '',
                no_printable_observations: '',
                buyer_code: '',
                contract_num: '',
                deliveries_relation_num: '',
                receiver_code_bill: '',
                receiver_code_goods: '',
                receiver_code_payment: '',
            },
        }
    },
    watch: {
        client: {
            immediate: true,
            handler(val) {
                if (val) {
                    this.fields.name = val.name
                    this.fields.legal_name = val.legal_name
                    this.fields.email = val.email
                    this.fields.cp = val.cp
                    this.fields.cif = val.cif
                    this.fields.address = val.address
                    this.fields.location = val.location
                    this.fields.state = val.state
                    this.fields.country = val.country
                    this.fields.phone = val.phone
                    this.fields.mobile_phone = val.mobile_phone
                    this.fields.rate = val?.rate
                    this.fields.iban = val.iban
                    this.fields.show_prices = val.show_prices
                    this.fields.bic_swift = val.bic_swift
                    this.fields.payment_method = val.payment_method || 0
                    this.fields.printable_observations = val.printable_observations
                    this.fields.no_printable_observations = val.no_printable_observations
                    this.fields.buyer_code = val.buyer_code
                    this.fields.contract_num = val.contract_num
                    this.fields.deliveries_relation_num = val.deliveries_relation_num
                    this.fields.receiver_code_bill = val.receiver_code_bill
                    this.fields.receiver_code_goods = val.receiver_code_goods
                    this.fields.receiver_code_payment = val.receiver_code_payment
                }
            },
        },
    },
    methods: {
        async save() {
            this.loading = true

            const params = {
                ...this.fields,
                rate: parseInt(this.fields.rate.key, 10) || null,
            }

            const res = await await this.$gestios.items('clients').edit({
                id: this.id,
                params,
            })

            if (res.ok) {
                this.$gestios.$message.success('Cliente actualizado correctamente 😄')
            }

            this.loading = false
        },
    },
}
</script>

<style lang="scss" module>
.headerIcon {
    font-size: 1.2rem;
    line-height: 1.2rem;
}
.generalCard {
    h5 {
        display: block;
        width: 100%;
    }
}
.rightTable {
    padding-top: 0 !important;
    padding-left: 0 !important;
    padding-right: 0 !important;
    border-radius: 0px !important;
}
.titleBig {
    text-transform: uppercase;
    font-weight: bold;
}
</style>
